export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13620.577b2b6c.jpg";